import { configureStore } from '@reduxjs/toolkit';
import { saveErrorToastMiddleware } from '@readcloud/state';
import rootReducer from './reducers';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'reduxjs-toolkit-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['PDFState', 'HomeSettingsState', 'SearchState'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (middleware) => [
    ...middleware({
      serializableCheck: {
        //https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
    saveErrorToastMiddleware,
  ],
  devTools: process.env.NODE_ENV === 'development',
});
export const persistor = persistStore(store);
export default store;
